
export default {
  async fetch() {
    const { $content, $i18n: { locale } } = this
    this.page = await $content(locale, 'pages/brands').fetch()
  },
  data() {
    return {
      page: null
    }
  }
}
